import React from 'react';
import PropTypes from 'prop-types';

export const Header = ({ roundNumber, matchData, matchID, ActiveMatch }) => {
    let fixture = '';
    if (matchID) {
        fixture = `- ${matchData?.home?.team?.name} v ${matchData?.away?.team?.name}`;
    }
    let roundTitle;
    if (matchData?.round) {
        roundTitle = matchData?.round?.name;
    } else {
        roundTitle = `Round ${roundNumber}`;
    }
    return (
        <header className="video-hub-video-listing__header js-round-header">
            <h2 className="video-hub-video-listing__title">
                {roundTitle} {ActiveMatch !== -1 ? fixture : ''}
            </h2>
        </header>
    );
};

Header.propTypes = {
    roundNumber: PropTypes.string,
    matchData: PropTypes.object,
    matchID: PropTypes.string,
    ActiveMatch: PropTypes.number
};
